import { render, staticRenderFns } from "./addAudio.vue?vue&type=template&id=510a08b0&scoped=true&"
import script from "./addAudio.vue?vue&type=script&lang=js&"
export * from "./addAudio.vue?vue&type=script&lang=js&"
import style0 from "./addAudio.vue?vue&type=style&index=0&id=510a08b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510a08b0",
  null
  
)

export default component.exports